<template>
  <div>
    <v-dialog v-model="show" v-if="show" persistent max-width="760">
      <v-card>
        <v-card-title class="headline" style="font-size:30px;">Error</v-card-title>
        <v-card-text style="font-size:20px;">
          <v-textarea rows="1" style="color:red;" disabled auto-grow :value="mensajeError"></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="cerrarModalEnAccion()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModalErrorEnAccion",
  props: {
    show: Boolean,
    mensajeError: String
  },
  methods: {
    cerrarModalEnAccion() {
      this.$emit("cerrarModalEnAccion");
    }
  }
};
</script>
